import { toKebabCase } from './toKebabCase';
import type { LucideIconData, LucideIconNode } from '../build/types';

/**
 * Converts legacy `(name, iconNode, aliases?)` icon arguments into icon data object format.
 */
export function toLucideIconData(
  iconName: string,
  iconNode: LucideIconNode[],
  aliases: string[] = [],
): LucideIconData {
  if (iconNode == null) {
    throw new Error('[lucide]: iconNode is required when icon name is used');
  }

  return {
    name: toKebabCase(iconName),
    size: 24,
    node: iconNode,
    ...(aliases.length > 0 ? { aliases } : {}),
  };
}
